import clsx from 'clsx';

import { classNamesFor } from '../../../utils/classNames';
import { Inset, InsetProps } from '../../containers/Inset';

const classNamesFactory = classNamesFor('DialogFootnote');

const classNames = {
  root: classNamesFactory.root(),
};

export type DialogFootnoteProps = InsetProps;

/**
 * DialogFootnote is a container component that displays content at the bottom of a dialog.
 * It provides a consistent styling and layout for footnotes within dialogs.
 */
export const DialogFootnote = ({
  children,
  testId = 'dialog-footnote',
  className,
  ...rest
}: DialogFootnoteProps) => {
  return (
    <Inset
      px
      py={12}
      // TODO (Justas): cover with token
      bgcolor="grey.900"
      className={clsx(classNames.root, className)}
      testId={testId}
      {...rest}
    >
      {children}
    </Inset>
  );
};

DialogFootnote.classNames = classNames;
